export default class Fetch {
	async send(endpoint, method = 'GET', body = {}, header = {}) {
		const headers = {
			"Content-Type": "application/json",
			...header
		}

		try {
			const response = await fetch(
				this.getRequestUrl(endpoint),
				{
				  method: method,
				  headers: headers,
				},
			)

			if (!response.ok) {
				return false;
			}

			const responseBody = await response.json();
			const responseHeaders = {};

			response.headers.forEach((value, key) => {
				responseHeaders[key] = value;
			});

			return {
				body: responseBody,
				headers: responseHeaders
			};

		} catch (error) {
			return null;
		}
	}

	getRequestUrl(endpoint) {
		return `https://biblia.parresia.com/wp-json/bible/v2/${endpoint}`;
	}

	buildQueryParamns(paramns) {
		const searchParams = {};

		for (const key in paramns) {
			if (Object.hasOwnProperty.call(paramns, key) && paramns[key]) {
				searchParams[key] = paramns[key];
			}
		}

		return (new URLSearchParams(searchParams)).toString();
	}
}
